import { Box, Theme, Typography } from "@outschool/backpack";
import { useTrackEvent } from "@outschool/ui-analytics";
import {
  ToggleButton,
  TrackingPageSection,
} from "@outschool/ui-legacy-component-library";
import React from "react";

import { CategoryTutoringFiltersProps } from "./HeroFilters";

const AGE_FILTERS: Array<string> = [
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "10",
  "11",
  "12",
  "13",
  "14",
  "15",
  "16",
  "17",
  "18",
];

function selectedAges(ages: string) {
  return ages?.split(",");
}

const TutoringCLPAgeFilter: React.FC<CategoryTutoringFiltersProps> = ({
  categorySlug,
  updateListings,
  label,
  searchFilters,
}) => {
  const trackEvent = useTrackEvent();
  return (
    <TrackingPageSection name="category_age_filters" uniqueId={"radio_buttons"}>
      {setImpressionNode => (
        <Box
          flex
          sx={{
            flexWrap: "wrap",
            gap: "10px",
          }}
          ref={setImpressionNode}
        >
          <Typography
            variant="h4"
            emphasized
            sx={(theme: Theme) => ({
              width: "100%",
              padding: "12px",
              [theme.breakpoints.up("md")]: {
                borderBottom: "1px solid",
                borderColor: theme.palette.grey[300],
              },
              [theme.breakpoints.down("md")]: {
                textAlign: "center",
              },
            })}
          >
            {label}
          </Typography>
          <Box
            flex
            sx={{
              flexWrap: "wrap",
              gap: "12px",
              paddingX: "1em",
              justifyContent: "center",
            }}
          >
            {AGE_FILTERS.map(age => {
              const enabled = selectedAges(searchFilters.age)?.includes(age);
              return (
                <ToggleButton
                  key={age}
                  enabled={enabled}
                  onClick={() => {
                    updateListings(age);
                    trackEvent("category_filter_click", {
                      categorySlug,
                      searchFilters: age,
                    });
                  }}
                  sx={{
                    width: "60px",
                    height: "40px",
                    color: enabled ? "white" : "primary",
                    borderColor: "primary",
                    borderWidth: "2px",
                  }}
                  value={age}
                >
                  {age}
                </ToggleButton>
              );
            })}
          </Box>
        </Box>
      )}
    </TrackingPageSection>
  );
};

export default TutoringCLPAgeFilter;
